import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigColumnDef } from './config-table.component';

@Component({
  selector: 'app-config-lead-stage',
  template: `<app-config-table
    tableName="Lead Stages"
    [columns]="columns"
    permissionKey="Config.Manage"
    [loadFn]="load"
    [createFn]="create"
    [updateFn]="update"
    [deactivateFn]="deactivate"
    [deleteFn]="delete">
  </app-config-table>`,
})
export class LeadStageConfigComponent {
  private rows: any[] = [];
  columns: ConfigColumnDef[] = [
    { field: 'name',        label: 'Name',       type: 'text',     required: true, maxLength: 64 },
    { field: 'description', label: 'Description', type: 'textarea', maxLength: 255 },
    { field: 'sortOrder',   label: 'Sort Order',  type: 'number' },
  ];

  constructor(private http: HttpClient) {
    this.load = () => this.http.get<any[]>('/api/lead-stages').pipe(
      tap(rows => { this.rows = rows; }),
    );
    this.create = (d: any) => this.http.post('/api/lead-stages', d);
    this.update = (id: any, d: any) => this.http.put(`/api/lead-stages/${id}`, d);
    this.deactivate = (id: any) => {
      const row = this.rows.find(candidate => candidate.id === id);
      return this.http.put<void>(`/api/lead-stages/${id}`, { ...row, isActive: false });
    };
    this.delete = (id: any) => this.http.delete<any>(`/api/lead-stages/${id}`);
  }

  load!: () => Observable<any[]>;
  create!: (d: any) => Observable<any>;
  update!: (id: any, d: any) => Observable<any>;
  deactivate!: (id: any) => Observable<void>;
  delete!: (id: any) => Observable<any>;
}
